export default "__VITE_ASSET__DYBWeFAP__"